module.exports = __webpack_public_path__ + "media/mypage/images/icons/sp_shikaku-7e1c4d9cb66bbf3f17716d209ec8d14f.svg";